module.exports = __webpack_public_path__ + "img/akusherstij-stacioner7.2836e76b.jpg";